import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';
import { S as StringService } from './index2.js';
import './index3.js';
import { T as TranslationService } from './index6.js';

const rocheEmptyStateCss = ":host{display:block;margin-top:3rem;margin-top:0;padding:0;color:var(--color-text--primary);font-family:\"roche-sans\";font-style:normal;font-weight:400;font-size:1.125rem;line-height:1.6875rem;display:flex;justify-content:center;color:#706b69;margin:8rem 0}@media (min-width: 90rem){:host{margin-top:4.5rem}}:host,:host *{box-sizing:border-box}@media (min-width: 64rem){:host{margin-top:0}}:host strong{font-weight:600}@media (min-width: 48rem){:host{font-size:1.125rem;line-height:1.8125rem}}@media (min-width: 90rem){:host{font-size:1.25rem;line-height:1.875rem}}@media (min-width: 48rem){:host{margin:10rem 0}}";
const RocheEmptyStateStyle0 = rocheEmptyStateCss;

const RocheEmptyState = /*@__PURE__*/ proxyCustomElement(class RocheEmptyState extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.translations = undefined;
    }
    async componentWillLoad() {
        this.translations = {
            noResultsFound: await TranslationService.translate('no results found'),
        };
    }
    render() {
        return (h(Host, { key: '56c446e63f0f74aacb87cc4173ec982c4b5e8668' }, StringService.capitalize(this.translations.noResultsFound)));
    }
    static get style() { return RocheEmptyStateStyle0; }
}, [1, "roche-empty-state", {
        "translations": [32]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["roche-empty-state"];
    components.forEach(tagName => { switch (tagName) {
        case "roche-empty-state":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, RocheEmptyState);
            }
            break;
    } });
}

export { RocheEmptyState as R, defineCustomElement as d };

//# sourceMappingURL=roche-empty-state2.js.map